import { useEffect, useRef } from 'react';
import { ReactComponent as ArrowBackIcon } from '../../assets/icons/arrow_back.svg';
import ChatBubble from './ChatBubble';
import { ResponseOption, TextMessage } from './phone_texts';

interface ConversationProps {
    name: string;
    messages: TextMessage[];
    suggestedResponses: ResponseOption[] | undefined;
    back: () => void;
    sendResponse: (response: ResponseOption) => void;
}

function useChatScroll<T>(
    dep: T
): React.MutableRefObject<HTMLDivElement | null> {
    const ref = useRef<HTMLDivElement | null>(null);
    useEffect(() => {
        if (ref.current) {
            ref.current.scrollTop = ref.current.scrollHeight;
        }
    }, [dep]);
    return ref;
}

function Conversation(props: ConversationProps) {
    const { name, messages, back, suggestedResponses, sendResponse } = props;

    const ref = useChatScroll(messages);

    return (
        <div className="phone-conversation" ref={ref}>
            <div>
                <div className="header">
                    <div className="back" onClick={back}>
                        <ArrowBackIcon />
                    </div>
                    {name}
                </div>
                {messages.map((message, i) => (
                    <div className="chat-bubble-wrapper" key={i}>
                        <ChatBubble
                            key={i}
                            message={message.message}
                            type={message.type}
                        />
                    </div>
                ))}
            </div>
            <div className="suggested-responses">
                {suggestedResponses?.map((response, i) => (
                    <ChatBubble
                        key={i}
                        message={
                            response.type === 'reply'
                                ? response.message
                                : 'Ignore'
                        }
                        type={response.type === 'reply' ? 'sent' : 'ignore'}
                        onClick={() => sendResponse(response)}
                    />
                ))}
            </div>
        </div>
    );
}

export default Conversation;
